"use strict";
"use strict";

jQuery(function () {
  /* HOMEPAGE
    Review Slick SLider */
  jQuery(".review-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    draggable: true,
    cssEase: "ease-in-out",
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: '<div class="slick-prev"></div>',
    nextArrow: '<div class="slick-next"></div>',
    responsive: [{
      breakpoint: 600,
      settings: {
        arrows: false
      }
    }]
  });
  /* ABOUT US
    Icon Content Slick SLider */

  jQuery(".icon-content-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    draggable: true,
    cssEase: "ease-in-out",
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 4,
    variableWidth: true,
    prevArrow: '<div class="slick-prev"></div>',
    nextArrow: '<div class="slick-next"></div>',
    responsive: [{
      breakpoint: 600,
      settings: {
        centerMode: true
      }
    }]
  });
  /* Announcement Close  */

  $("#announcement-close").on("click", function () {
    $(".announcement-bar").hide();
    $("body").removeClass("announcement-visible");
  });
  /* MEGAMENU
    active link while submenu open */

  $(".js-shop-menu .site-nav__link,.js-shop-menu .submenu").mouseover(function () {
    $(".js-shop-menu .site-nav__link").css("border-bottom", "5px solid #9ad82f");
  });
  $(".js-shop-menu .site-nav__link,.js-shop-menu .submenu").mouseout(function () {
    $(".js-shop-menu .site-nav__link").css("border-bottom", "none");
  });
  $(".js-installation-menu .site-nav__link,.js-installation-menu .submenu").mouseover(function () {
    $(".js-installation-menu .site-nav__link").css("border-bottom", "5px solid #9ad82f");
  });
  $(".js-installation-menu .site-nav__link,.js-installation-menu .submenu").mouseout(function () {
    $(".js-installation-menu .site-nav__link").css("border-bottom", "none");
  });
  $(".js-support-menu .site-nav__link,.js-support-menu .submenu").mouseover(function () {
    $(".js-support-menu .site-nav__link").css("border-bottom", "5px solid #9ad82f");
  });
  $(".js-support-menu .site-nav__link,.js-support-menu .submenu").mouseout(function () {
    $(".js-support-menu .site-nav__link").css("border-bottom", "none");
  });
  /* HEADER CART
    Cart Open Close  */

  $(".js-cart-expand").on("click", function () {
    $("#CartSidebar").toggleClass("active");
  });
  $("#cart-close").on("click", function () {
    $("#CartSidebar").removeClass("active");
  });
  /* FAQ
    Accordion JS */

  $(".accordion-toggle").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".accordion-content").slideUp(200);
    } else {
      $(".accordion-toggle").removeClass("active");
      $(this).addClass("active");
      $(".accordion-content").slideUp(200);
      $(this).siblings(".accordion-content").slideDown(200);
    }
  });
  /* COMMON
    Scroll to particular Div with # value */

  $('a[href^="#"]').on("click", function (event) {
    var target = $(this.getAttribute("href"));

    if (target.length) {
      event.preventDefault();
      $("html, body").stop().animate({
        scrollTop: target.offset().top - 100
      }, 1000);
    }
  });
});
/** Mobile Navigation Open Close **/

function nav_open() {
  $("#navbarNavDropdown").toggleClass("active");
  $("#hamburger").toggleClass("active");
  $("#CartSidebar").removeClass("active");
}
/** Mobile SubMenu Open Close **/


(function ($) {
  $(function () {
    // If a link has a dropdown, add sub menu toggle.
    $(".has-big-nav .site-nav__link").click(function (e) {
      // $(this).toggleClass("active");
      $(this).siblings(".submenu").toggleClass("active");
      e.stopPropagation();

      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".submenu").slideUp(200);
      } else {
        $(".has-big-nav .site-nav__link").removeClass("active");
        $(this).addClass("active");
        $(".submenu").slideUp(200);
        $(this).siblings(".submenu").slideDown(200);
      }
    });
  });
})(jQuery);
/** Fix Header on Scroll **/


$(window).scroll(function () {
  var sticky = $("header"),
      scroll = $(window).scrollTop();

  if (scroll >= 100) {
    sticky.addClass("up");

    if (scroll >= 500) {
      sticky.removeClass("up");
      sticky.addClass("fixed");
    }
  } else {
    sticky.removeClass("fixed");
    sticky.removeClass("up");
  }
});
$(document).mouseup(function (e) {
  var popup = $("#CartSidebar");

  if (!popup.is(e.target) && popup.has(e.target).length == 0) {
    popup.removeClass("active");
  }
});
$(document).ready(function () {
  $("footer").removeAttr("data-aos");
  $("footer").removeAttr("data-aos-duration");

  if ($("body").hasClass("template-index")) {
    $("footer").attr("data-aos", "fade-up");
    $("footer").attr("data-aos-duration", "500");
  }

  $("#js-open-new-message-chat").on("click", function () {
    Intercom("showNewMessage");
  });
  $("#js-open-chat").on("click", function () {
    Intercom('show');
  });
});
"use strict";

/*******
DECLARE VARIABLES
*******/
var variantArray = [];
var variantOptionArray = {};
var selectedVariantArray;
var selectedVariantID;
$(document).ready(function ($) {
  /*Clear bold pre select timer*/
  function stopBoldPreSelectTimer() {
    clearInterval(boldPreSelectTimer);
    console.log("myStopFunction");
  }

  var boldTimer = false;
  var boldPreSelectTimer;
  console.log(localStorage.getItem("motor"));
  /*Checking local storage if local storage not null then set interval function active*/

  if (localStorage.getItem("motor") != null) {
    boldPreSelectTimer = setInterval(boldOptionPreSelect, 1000);
  }
  /*Bold option pre select*/


  function boldOptionPreSelect() {
    console.log("boldOptionPreSelect");

    try {
      var retrievedData = localStorage.getItem("motor");
      var motor = JSON.parse(retrievedData);

      if (window.location.href.toLowerCase().indexOf(motor["final product handler"]) > -1) {
        $(".bold_option_set .bold_option.bold_option_swatch").each(function (index) {
          var title = $(this).children(".bold_option_title").html().toLowerCase().trim().replace("*", "");

          if (title == "battery") {
            title = "battery ba 1 title";
          }

          if (title.indexOf("rear rack") > -1) {
            title = "battery ba 2";
          }

          var checkboxs = $(this).children(".bold_option_element").children(".bold_option_value").children("label").children(".bold_option_value_element").children("input[type=checkbox]");
          var checkboxsLabels = $(this).children(".bold_option_element").children(".bold_option_value").children("label");
          $(this).children(".bold_option_element").children(".bold_option_value").each(function (index) {
            var checkboxValue = $(this).children("label").children(".bold_option_swatch_title").children(".bold_option_value_title").html().toLowerCase();

            if (checkboxValue.indexOf(motor[title]) > -1) {
              checkboxs.attr("checked", false);
              checkboxsLabels.removeClass("selected"); // $(this).children("label").children(".bold_option_value_element").children("input[type=checkbox]").attr("checked", true);
              //$(this).children("label").children(".bold_option_value_element").children("input[type=checkbox]").click();
              //$(this).children("label").addClass("selected");

              priceUpdate();
              $(this).children("label").click();
              boldTimer = true;
            }
          });
        });
        $(".bold_option_set .bold_option.bold_option_swatch").each(function (index) {
          $(this).children(".bold_option_element").children(".bold_option_value").each(function (index) {
            if ($(this).children("label").children(".bold_option_value_element").children("input[type=checkbox]").is(":checked")) {
              $(this).children("label").addClass("selected");
              boldTimer = true;
            }
          });
        });
      }
      /*After all working of bold preselect cleared interval*/


      if (boldTimer == true) {
        stopBoldPreSelectTimer();
      }
    } catch (err) {}
  }
  /* accordion working about content in small screen*/


  $(".js-accordian").children("li").children("h4").click(function (e) {
    if ($(this).parent("li").children(".content").css("display") == "none") {
      $(".js-accordian").children("li").children(".content").hide();
      $(".js-accordian").children("li").removeClass("active");
      $(this).parent("li").children(".content").slideDown();
      $(this).parent("li").addClass("active");
      $('html,body').animate({
        scrollTop: $(this).offset().top - 120
      }, 500);
    } else {
      $(this).parent("li").children(".content").slideUp();
      $(this).parent("li").removeClass("active");
    }
  });
  /* Slider for product images in the product details page */

  var $productDetailImages = $(".productDetailImages").owlCarousel({
    loop: false,
    margin: 0,
    nav: false,
    mouseDrag: false,
    touchDrag: true,
    dots: false,
    autoplay: false,
    autoplayTimeout: 5000,
    autoHeight: true,
    URLhashListener: true,
    autoplayHoverPause: true,
    startPosition: 'URLHash',
    items: 1
  });
  var $productDetailThumbImages = $(".productDetailThumbImages").owlCarousel({
    loop: false,
    margin: 10,
    nav: true,
    mouseDrag: false,
    touchDrag: true,
    dots: false,
    autoplay: false,
    autoplayTimeout: 5000,
    autoHeight: true,
    URLhashListener: true,
    autoplayHoverPause: true,
    startPosition: 'URLHash',
    items: 6,
    responsive: {
      0: {
        items: 3
      },
      481: {
        items: 4
      },
      601: {
        items: 6
      }
    }
  });
  $(".productDetailThumbImages .owl-item li").first().addClass("active");
  ;
  $(".productDetailThumbImages li").on("click", function () {
    $(".productDetailThumbImages li").removeClass("active");
    $(this).addClass("active");
    var idx = $(this).parent(".owl-item").index();
    $productDetailImages.trigger('to.owl.carousel', idx, 100);
    /* $(this).removeClass("active");
     if($(this).hasClass("active")){
       $(this).removeClass("active");
     } else{
       $("li.active").removeClass("active");
       $(this).addClass("active");
     }*/
  });
  /* ON PAGE LOAD
   Get the value of the checked radio button for all the types
  get the name and value e.g. name = color, value = red */

  $(".js-fieldset-variant .variantsRadioSectionOption .variantsRadioOption input:checked").each(function (index) {
    var variantKey = $(this).attr("name");
    var variantValue = $(this).val();
    /* Adding a map of name to value */

    variantOptionArray[variantKey] = variantValue;
    variantSelection(this);
  });
  /*******
  RADIO BUTTON CLICK 
  *******/

  $(".product-actions-wrapper .optionRadio").click(function (e) {
    /*console.log("------------------------- BEGIN------------------");*/
    variantSelection(this);
  });

  function variantSelection(passedElement) {
    //$(".js-add-to-cart-btn").addClass("hide");
    // $(".js-add-to-cart-btn").prop("disabled", true);

    /*
    Get the clicked radio button  name and value
    */
    var variantValue = $(passedElement).parent(".variantsRadioOption").children("input").val();
    var variantKey = $(passedElement).parent(".variantsRadioOption").children("input").attr("name");
    /* Check if the key exists in the array or not 
    if it exists, then update the key with the new value
    e.g. on load color = red
    but on click  - color = blue
    */

    if (variantKey in variantOptionArray) {
      // console.log("TRUEEEEEEE KEY EXISTS IN THE ARRAY");
      // console.log(variantKey);
      variantOptionArray[variantKey] = variantValue; // if key exists, then don't do anything
    }
    /* Set the variant ID */


    loopThroughProductLiquidVariable();
    /* go through each select options */

    $(".selector-wrapper").each(function (index) {
      var checkSelectLabelVal = $(this).children("label").text().toLowerCase();

      if (checkSelectLabelVal == variantKey) {
        //console.log($(this).children("label").text().toLowerCase());

        /*fire the select change for that option and set it's value */
        $(this).children("select").val(variantValue);
        $(this).children("select").change();
      }
    });
  }

  function loopThroughProductLiquidVariable() {
    selectedVariantArray = Object.keys(variantOptionArray); // console.log(selectedVariantArray);
    //console.log(selectedVariantArray.length);
    // console.log("1" + selectedVariantArray[0]);
    // console.log("2" + selectedVariantArray[1]);
    // console.log("3" + variantOptionArray[selectedVariantArray[0]]);
    // console.log("4" + variantOptionArray[selectedVariantArray[1]]);
    // console.log("5" + variantOptionArray[selectedVariantArray[2]]);

    /* get the variant ID */

    $.each(prodLib, function (key, value) {
      if (selectedVariantArray.length == 1 && variantOptionArray[selectedVariantArray[0]] == value.option1) {
        selectedVariantID = value.id;
        $(".js-add-to-cart-btn").removeClass("hide");
      }

      if (selectedVariantArray.length == 2 && variantOptionArray[selectedVariantArray[0]] == value.option1 && variantOptionArray[selectedVariantArray[1]] == value.option2) {
        selectedVariantID = value.id;
        $(".js-add-to-cart-btn").removeClass("hide");
      }

      if (selectedVariantArray.length == 3 && variantOptionArray[selectedVariantArray[0]] == value.option1 && variantOptionArray[selectedVariantArray[1]] == value.option2 && variantOptionArray[selectedVariantArray[2]] == value.option3) {
        //  console.log("case 3");
        //  console.log(value.id);
        // console.log("price: " + value.price);
        // console.log("compared price: " + value.priceCompared);
        selectedVariantID = value.id;
        $(".js-add-to-cart-btn").removeClass("hide");
      }
    });
  }
  /*variant-dropdown working*/


  $('.js-variant-dropdown .variant-dropdown-selected').click(function () {
    if ($(this).parent(".js-variant-dropdown").children("ul").css("display") == "none") {
      $(this).parent(".js-variant-dropdown").addClass("active");
      $(this).parent(".js-variant-dropdown").children("ul").slideDown();
    } else {
      $(this).parent(".js-variant-dropdown").removeClass("active");
      $(this).parent(".js-variant-dropdown").children("ul").slideUp();
    }
  });
  /* Add to cart working */

  $('.js-add-to-cart-btn').click(function () {
    if (prodLib.length == 0) {
      selectedVariantID = $('.js-add-to-cart-btn').attr('data-attr-itemid');
      console.log("selectedVariantID: when NULL: " + selectedVariantID);
    } else {
      console.log("selectedVariantID:: " + selectedVariantID);
    }

    var submitCartText = $('#submitCart').html().toLowerCase();

    if (submitCartText == "add to cart") {
      /* Pass the object after 2 seconds */
      var getCartItemObject = function getCartItemObject() {
        if (cartSuccess) {
          console.log(CartJS.cart.items);
          console.log(CartJS.cart.item_count);
          console.log(CartJS.cart);
          /* if cart items are > 0 then show the mini cart */

          if (CartJS.cart.item_count > 0) {
            $("#CartSidebar").addClass("active");
          }

          reloadAjaxCartItems(CartJS.cart);
        }
      };

      var cartSuccess = false;
      var quantity = parseInt($('.js-quantity-selector').val());
      CartJS.addItem(selectedVariantID, quantity, {}, {
        "success": function success(response, textStatus, jqXHR) {
          CartJS.getNote(); // console.log(response);
          // console.log(CartJS.cart);

          cartSuccess = true;
          setTimeout(getCartItemObject, 2000);
          /* Show message */

          $('#cart-message').addClass('message-success');
          $('#cart-message').removeClass('message-error');
          $('#cart-message').html('Successfully added to cart!');
          $('#cart-message').show();
          setTimeout(function () {
            $('#cart-message').hide();
          }, 2000);
        },
        // Define an error callback to display an error message.

        /* 
        Need to add a div to show the error if something went wrong
        */
        "error": function error(jqXHR, textStatus, errorThrown) {
          console.log("Something went wrong");
          $('#cart-message').removeClass('message-success');
          $('#cart-message').addClass('message-error');
          $('#cart-message').html('There was a problem adding to the cart!');
          $('#cart-message').show();
          setTimeout(function () {
            $('#cart-message').hide();
          }, 2000);
        }
      });
    }
  });
  /*Quantity Plus Minus*/

  $(".js-product-single__quantity .js-minus-qty").click(function () {
    var productQuantity = $(".js-quantity-selector").val();

    if (productQuantity > 1) {
      productQuantity--;
    }

    $(".js-quantity-selector").val(productQuantity);
  });
  $(".js-product-single__quantity .js-plus-qty").click(function () {
    var productQuantity = $(".js-quantity-selector").val();
    productQuantity++;
    $(".js-quantity-selector").val(productQuantity);
  }); //    var quizInterval =  setInterval(function(){ 
  //     boldAttachClicks();
  //     }, 100);
  // function boldAttachClicks()
  // {
  // }

  /* Bold Clicks */

  /*Checkbox click*/

  $(document).on("click", ".bold_option_checkboxmulti label", function () {
    if ($(this).children(".bold_option_value_element").children("input").is(':checked')) {
      $(this).addClass("selected");
    } else {
      $(this).removeClass("selected");
    }

    priceUpdate();
  });
  $(document).on("click", ".bold_option_radio label", function () {
    $(this).parent(".bold_option_value").parent(".bold_option_element").parent(".bold_option_radio").children(".bold_option_element").children(".bold_option_value").children("label").removeClass("selected");

    if ($(this).children(".bold_option_value_element").children("input").is(':checked')) {
      $(this).addClass("selected");
    } else {
      $(this).removeClass("selected");
    }

    priceUpdate();
  });
  $(document).on("click", ".bold_option_swatch label", function () {
    $(this).parent(".bold_option_value").parent(".bold_option_element").parent(".bold_option_swatch").children(".bold_option_element").children(".bold_option_value").children("label").removeClass("selected");

    if ($(this).children(".bold_option_value_element").children("input[type='checkbox']").prop("checked") == true) {
      $(this).addClass("selected");
    } else {
      $(this).removeClass("selected");
    }

    priceUpdate();
  });

  function priceUpdate() {
    console.log("price-update");
    setTimeout(function () {
      if ($(".bold_option_total").children("div").children('span').html() != undefined) {
        $(".bold_option_total").addClass("hide");
        var priceProduct = $("#ProductPrice").html().replace("$", "");
        var priceBold = $(".bold_option_total").children("div").children('span').html().replace("$", "");
        priceProduct = parseFloat(priceProduct);
        priceBold = parseFloat(priceBold);
        var priceTotal = parseFloat(priceProduct) + parseFloat(priceBold);
        $(".js-total-price").html("$" + priceTotal.toFixed(2));
        $(".js-total-price").show();
      } else {
        $(".js-total-price").hide();
      }
    }, 1000);
  }
}); //  var quizInterval =  setInterval(function(){ 
//   boldLoopThrough();
//   }, 100);
"use strict";

var motor;
$(document).ready(function ($) {
  $(".js-bracket-diameter-other-close").click(function (e) {
    $(".js-bracket-diameter-other-popup").hide();
  });
  $(".js-quiz-bracket-diameter-other").click(function (e) {
    $(".js-bracket-diameter-other-popup").show();
  });
  $(".js-bracket-diameter-other-continue").click(function (e) {
    $(".quiz-section").removeClass("active");
    $(".quiz-section").hide();
    $(".js-bracket-diameter-other").hide();
    motor["bracket diameter"] = "other";
    $(".js-quiz-section-bracket-thickness").addClass("active");
    $(".js-quiz-section-bracket-thickness").show();
    $(".js-bracket-diameter-other-popup").hide();
    $('html,body').animate({
      scrollTop: $(".quiz-box").offset().top - 200
    }, 500);
  });
  /*Intro screen click*/

  $(".js-quiz-intros .js-intro-step").click(function (e) {
    var step = $(this).attr("data-intro-step");
    $(".quiz-intro-section").removeClass("active");
    $(".quiz-intro-section").hide();
    $(".js-quiz-intro-section-" + step).addClass("active");
    $(".js-quiz-intro-section-" + step).show();
    $('html,body').animate({
      scrollTop: $(".quiz-box").offset().top - 200
    }, 500);
  });
  /*No Result click*/

  $(".js-noresult-btn").click(function (e) {
    var step = $(this).attr("data-intro-step");
    $(".quiz-section-noresult").hide();
    $(".quiz-intro-section").removeClass("active");
    $(".quiz-intro-section").hide();
    $(".js-quiz-intro-section-" + step).addClass("active");
    $(".js-quiz-intro-section-" + step).show();
    $('html,body').animate({
      scrollTop: $(".quiz-box").offset().top - 200
    }, 500);
  });
  var quizSection = "";
  /*Intro screen type select*/

  $(".js-quiz-intros .js-btn-quiz-section").click(function (e) {
    quizSection = $(this).attr("data-quiz-section");
    $(".quiz-intro-section").removeClass("active");
    $(".quiz-intro-section").hide();
    $(".js-quiz-section-" + quizSection).show();
    $(".js-quiz-section-" + quizSection).addClass("active");

    if (quizSection == "front" || quizSection == "discover") {
      $(".js-quiz-section-drop-out-type").show();
      $(".js-quiz-section-drop-out-type").addClass("active");
    } else {
      $(".js-quiz-section-bracket-size").show();
      $(".js-quiz-section-bracket-size").addClass("active");
    }

    motor = {};
    motor["type"] = quizSection;
    motor["front status"] = false;
    $('html,body').animate({
      scrollTop: $(".quiz-box").offset().top - 200
    }, 500);
  });
  /* No result*/

  function noResult() {
    $(".js-quiz-section").hide();
    $(".quiz-section-result-loader").show();
    setTimeout(function () {
      $(".quiz-section-noresult").show();
      $(".quiz-section-result-loader").hide();
    }, 2000);
  }
  /* initial result*/


  function initialResult() {
    $(".quiz-section-result-loader").show();
    $(".js-quiz-note").hide();
    $(".js-btn-ba-one-previous").attr("data-prev-step", "section-initial-result");
    setTimeout(function () {
      $(".js-quiz-section-initial-result").show();
      $(".js-quiz-note").show();
      $(".quiz-section-result-loader").hide();
    }, 2000);
    $(".single-front-hub-motor").show();
    $(".single-mid-drive-bbs02").hide();
    $(".single-mid-drive-bbshd").hide();
  }
  /* Final result*/


  function finalResult() {
    $(".quiz-section-result-loader").show();
    $(".js-quiz-note").hide();
    setTimeout(function () {
      $(".js-quiz-section-final-result").show();
      $(".js-quiz-note").show();
      $(".quiz-section-result-loader").hide();
    }, 2000);

    if (motor["type"] == "front") {
      $(".front-final-result").show();
      $(".mid-final-result").hide();
      $(".js-result-motor-value").html('FRONT HUB');
    } else if (motor["type"] == "mid") {
      $(".front-final-result").hide();
      $(".mid-final-result").show();
      $(".js-mid-motor-type").show();
      $(".js-result-motor-value").html('MID DRIVE');
    } else {
      $(".front-final-result").show();
      $(".mid-final-result").show();
      $(".js-mid-motor-type").hide();
      $(".js-result-motor-value").html('DISCOVER');
    }

    $(".js-drop-type-value").html(motor["drop out type"]);
    $(".js-fork-size-value").html(motor["fork width"]);
    $(".js-wheel-size-value").html(motor["wheel size"]);
    $(".js-bracket-size-value").html(motor["bracket size"]);
    $(".js-bracket-diameter-value").html(motor["bracket diameter"]);
    $(".js-bracket-thickness-value").html(motor["bracket thicknes"]);
    $(".js-battery-selection-value").html(motor["battery ba 1 title"]);
    $(".js-mounting-option-value").html(motor["battery ba 2"]);

    try {
      motor["bracket diameter"] = motor["bracket diameter"].replace("*", "");
    } catch (err) {}

    if (motor["bracket diameter"] == "other") {
      $(".js-other-info").show();
    } else {
      $(".js-other-info").hide();
    }

    localStorage.setItem("motor", JSON.stringify(motor));
  }
  /*Front step one click*/


  $(".js-quiz-step").click(function (e) {
    var quizType = $(this).attr("data-type").toLowerCase();
    var selectedValue = $(this).html().toLowerCase().trim();
    var quizStep = $(this).attr("data-step");
    $(".quiz-section").removeClass("active");
    $(".quiz-section").hide();

    if (selectedValue.toLowerCase() == "closed system" && motor["type"] == "front") {
      noResult();
    } else if (selectedValue.toLowerCase() == "cutout does not fit" && motor["type"] == "front") {
      noResult();
    } else if (selectedValue.toLowerCase() == "more than 12mm") {
      /* $(".js-quiz-section").hide();
       $(".quiz-section-try-wider-motor").show();*/
      if (motor["type"] == "discover") {
        if (motor["front status"] == true) {
          motor["front product handle"] = "front product handle";
          initialResult();
        } else {
          noResult();
        }
      } else {
        noResult();
      }
    } else if (selectedValue.toLowerCase() == "no") {
      if (motor["bracket size"] == "101-120mm") {
        if (motor["type"] == "discover") {
          if (motor["front status"] == true) {
            motor["front product handle"] = "front product handle";
            initialResult();
          } else {
            noResult();
          }
        } else {
          noResult();
        }
      } else {
        $(".js-quiz-section").hide();
        $(".quiz-section-try-wider-motor").show();
      }
    } else if (selectedValue.toLowerCase() == "yes") {
      $(".quiz-section-result-loader").show();
      $(".js-quiz-note").hide();
      motor["mid product 1"] = "BBS02 1000w".toLocaleLowerCase();
      setTimeout(function () {
        if (motor["type"] == "discover") {
          if (motor["front status"] == true) {
            motor["front product handle"] = "front product handle";
            $(".js-quiz-section-initial-result-both").show();
            $(".js-btn-ba-one-previous").attr("data-prev-step", "section-initial-result-both");
            $(".both-front-hub-motor").show();
            $(".both-mid-drive-bbs02").hide();
            $(".both-mid-drive-bbshd").show();
          } else {
            $(".js-quiz-section-initial-result").show();
            $(".js-btn-ba-one-previous").attr("data-prev-step", "section-initial-result");
            $(".single-front-hub-motor").hide();
            $(".single-mid-drive-bbs02").hide();
            $(".single-mid-drive-bbshd").show();
          }
        } else {
          $(".js-quiz-section-initial-result").show();
          $(".js-btn-ba-one-previous").attr("data-prev-step", "section-initial-result");
          $(".single-front-hub-motor").hide();
          $(".single-mid-drive-bbs02").hide();
          $(".single-mid-drive-bbshd").show();
        }

        $(".js-quiz-note").show();
        $(".quiz-section-result-loader").hide();
      }, 2000);
    } else if (quizType == "obstruct") {
      if (selectedValue == "750 w") {
        motor["mid product 1"] = "BBS02 750".toLocaleLowerCase();
      } else if (selectedValue == "1000 w") {
        motor["mid product 1"] = "BBS02 1000w".toLocaleLowerCase();
      } else if (selectedValue == "both fit") {
        motor["mid product 1"] = "BBS02 750".toLocaleLowerCase();
        motor["mid product 2"] = "BBSHD 1000w".toLocaleLowerCase();
      } else {
        if (motor["bracket size"] == "101-120mm") {
          if (motor["type"] == "discover") {
            if (motor["front status"] == true) {
              motor["front product handle"] = "front product handle";
              initialResult();
            } else {
              noResult();
            }
          } else {
            noResult();
          }
        } else {
          $(".js-quiz-section").hide();
          $(".quiz-section-try-wider-motor").show();
        }
      }

      if (selectedValue != "none") {
        $(".quiz-section-result-loader").show();
        $(".js-quiz-note").hide();
        setTimeout(function () {
          if (motor["type"] == "discover") {
            if (motor["front status"] == true) {
              motor["front product handle"] = "front product handle";

              if (selectedValue == "both fit") {
                $(".js-quiz-section-initial-result-three-product").show();
                $(".js-btn-ba-one-previous").attr("data-prev-step", "section-initial-result-three-product");
              } else {
                $(".both-mid-drive-bbshd").hide();
                $(".both-mid-drive-bbs02").hide();

                if (selectedValue == "750 w") {
                  $(".both-mid-drive-bbs02").show();
                } else {
                  $(".both-mid-drive-bbshd").show();
                }

                $(".both-front-hub-motor").show();
                $(".js-quiz-section-initial-result-both").show();
                $(".js-btn-ba-one-previous").attr("data-prev-step", "section-initial-result-both");
              }
            } else {
              if (selectedValue == "both fit") {
                $(".js-quiz-section-initial-result-both").show();
                $(".js-btn-ba-one-previous").attr("data-prev-step", "section-initial-result-both");
                $(".both-front-hub-motor").hide();
                $(".both-mid-drive-bbs02").show();
                $(".both-mid-drive-bbshd").show();
              } else {
                $(".single-mid-drive-bbshd").hide();
                $(".single-mid-drive-bbs02").hide();

                if (selectedValue == "750 w") {
                  $(".single-mid-drive-bbs02").show();
                } else {
                  $(".single-mid-drive-bbshd").show();
                }

                $(".single-front-hub-motor").hide();
                $(".js-quiz-section-initial-result").show();
                $(".js-btn-ba-one-previous").attr("data-prev-step", "section-initial-result");
              }
            }
          } else {
            if (selectedValue == "both fit") {
              $(".both-front-hub-motor").hide();
              $(".both-mid-drive-bbs02").show();
              $(".both-mid-drive-bbshd").show();
              $(".js-quiz-section-initial-result-both").show();
              $(".js-btn-ba-one-previous").attr("data-prev-step", "section-initial-result-both");
            } else {
              $(".single-mid-drive-bbshd").hide();
              $(".single-mid-drive-bbs02").hide();

              if (selectedValue == "750 w") {
                $(".single-mid-drive-bbs02").show();
              } else {
                $(".single-mid-drive-bbshd").show();
              }

              $(".single-front-hub-motor").hide();
              $(".js-quiz-section-initial-result").show();
              $(".js-btn-ba-one-previous").attr("data-prev-step", "section-initial-result");
            }
          }

          $(".js-quiz-note").show();
          $(".quiz-section-result-loader").hide();
        }, 2000);
      }
    } else if (motor["type"] == "discover") {
      if (selectedValue.toLowerCase() == "closed system" || selectedValue.toLowerCase() == "cutout does not fit") {
        motor["front status"] = false;
        $(".js-quiz-section-bracket-size").addClass("active");
        $(".js-quiz-section-bracket-size").show();
      } else {
        $(".js-quiz-section-" + quizStep).addClass("active");
        $(".js-quiz-section-" + quizStep).show();
      }
    } else {
      $(".js-quiz-section-" + quizStep).addClass("active");
      $(".js-quiz-section-" + quizStep).show();
    } // motor["mid product 1"] = "BBS02 750".toLocaleLowerCase();
    //motor["mid product 2"] = "BBSHD 1000w".toLocaleLowerCase();


    motor[quizType] = selectedValue;
    $('html,body').animate({
      scrollTop: $(".quiz-box").offset().top - 200
    }, 500);
  });
  /*Previous button click*/

  $(".quiz-section .js-btn-previous").click(function (e) {
    var quizPrevStep = $(this).attr("data-prev-step");
    $(".quiz-intro-section").removeClass("active");
    $(".quiz-intro-section").hide();
    $(".quiz-section").removeClass("active");
    $(".quiz-section").hide();
    $(".js-quiz-" + quizPrevStep).addClass("active");
    $(".js-quiz-" + quizPrevStep).show();
    $('html,body').animate({
      scrollTop: $(".quiz-box").offset().top - 200
    }, 500);
  });
  $(".js-btn-previous-bracket-size").click(function (e) {
    $(".quiz-intro-section").removeClass("active");
    $(".quiz-intro-section").hide();
    $(".quiz-section").removeClass("active");
    $(".quiz-section").hide();

    if (motor["type"] == "discover") {
      $(".js-quiz-section-wheelsize").addClass("active");
      $(".js-quiz-section-wheelsize").show();
    } else {
      $(".js-quiz-intro-section-four").addClass("active");
      $(".js-quiz-intro-section-four").show();
    }

    $('html,body').animate({
      scrollTop: $(".quiz-box").offset().top - 200
    }, 500);
  });
  /*Wheel size button click*/

  $(".js-quiz-btn-wheel-size").click(function (e) {
    var wheelSize = $(".js-quiz-wheel-size").val();
    $(".quiz-section").removeClass("active");
    $(".quiz-section").hide();
    motor["front status"] = false;
    motor["wheel size"] = wheelSize;

    if (motor["drop out type"].toLowerCase() != "closed system" && motor["fork width"].toLowerCase() != "cutout does not fit" && motor["wheel size"].toLowerCase() != "none of the above") {
      motor["front status"] = true;
    }

    if (wheelSize.toLowerCase() == "none of the above" && motor["type"] == "front") {
      if (motor["type"] == "discover") {
        motor["front status"] = false;
        $(".js-quiz-section-bracket-size").addClass("active");
        $(".js-quiz-section-bracket-size").show();
      } else {
        noResult();
      }
    } else {
      if (motor["type"] == "front") {
        motor["front product handle"] = "front product handle";
        initialResult();
      } else {
        $(".js-quiz-section-bracket-size").show();
      }
    }

    $('html,body').animate({
      scrollTop: $(".quiz-box").offset().top - 200
    }, 500);
  });
  /*Bracket size button click*/

  $(".js-quiz-btn-bracket-size").click(function (e) {
    var bracketSize = $(".js-quiz-bracket-size").val().toLowerCase();
    $(".quiz-section").removeClass("active");
    motor["bracket size"] = bracketSize;
    $(".js-quiz-section").hide();
    $(".quiz-section").hide();
    $(".js-quiz-section-bracket-diameter").show();
    $(".js-quiz-section-bracket-diameter").addClass("active");

    if (bracketSize.toLowerCase() == "68-73mm") {
      motor["bracket size"] = bracketSize;
      $(".js-mid-drive-obstruction-68-73").show();
      $(".js-mid-drive-obstruction-74-100").hide();
      $(".js-mid-drive-obstruction-100-120").hide(); // motor["mid product 1"] = "BBS02 750".toLocaleLowerCase();
      //motor["mid product 2"] = "BBSHD 1000w".toLocaleLowerCase();
    } else if (bracketSize.toLowerCase() == "74-100mm") {
      $(".js-mid-drive-obstruction-68-73").hide();
      $(".js-mid-drive-obstruction-74-100").show();
      $(".js-mid-drive-obstruction-100-120").hide();
    } else {
      $(".js-mid-drive-obstruction-68-73").hide();
      $(".js-mid-drive-obstruction-74-100").hide();
      $(".js-mid-drive-obstruction-100-120").show();
      motor["mid product 1"] = "BBSHD 1000w".toLocaleLowerCase();
    }

    $('html,body').animate({
      scrollTop: $(".quiz-box").offset().top - 200
    }, 500);
  });
  /*Wider motor button click*/

  $(".js-quiz-btn-try-wider-motor").click(function (e) {
    var widermotorValue = $(this).attr("data-attr").toLowerCase();
    $(".quiz-section-try-wider-motor").hide();
    $(".quiz-section").removeClass("active");

    if (widermotorValue == "yes") {
      motor["mid product 1"] = null;
      motor["mid product 2"] = null;
      $(".js-quiz-section-obstruct").show();
      $(".js-obstruct-previous-section").hide();
      $(".js-quiz-section-obstruct").addClass("active");

      if (motor["bracket size"] == "68-73mm") {
        motor["bracket size"] = "74-100mm";
        $(".js-mid-drive-obstruction-68-73").hide();
        $(".js-mid-drive-obstruction-74-100").show();
        $(".js-mid-drive-obstruction-100-120").hide();
      } else if (motor["bracket size"] == "74-100mm") {
        motor["bracket size"] = "101-120mm";
        $(".js-mid-drive-obstruction-68-73").hide();
        $(".js-mid-drive-obstruction-74-100").hide();
        $(".js-mid-drive-obstruction-100-120").show();
      } else {
        motor["bracket size"] = "68-73mm";
        $(".js-mid-drive-obstruction-68-73").shiw();
        $(".js-mid-drive-obstruction-74-100").hide();
        $(".js-mid-drive-obstruction-100-120").hide();
      }
    } else {
      if (motor["type"] == "discover") {
        if (motor["front status"] == true) {
          motor["front product handle"] = "front product handle";
          initialResult();
        } else {
          noResult();
        }
      } else {
        noResult();
      }
    }

    $('html,body').animate({
      scrollTop: $(".quiz-box").offset().top - 200
    }, 500);
  });
  $(".js-initial-result-continue").click(function (e) {
    $(".js-quiz-section-initial-result").hide();
    $(".js-quiz-section-initial-result-both").hide();
    $(".js-quiz-section-initial-result-three-product").hide();
    $(".quiz-section").removeClass("active");
    $(".js-quiz-section-battery-ba1").show();
    $(".js-quiz-section-battery-ba1").addClass("active"); //  productFrontHubMotorBattery

    var productHandler = $(this).attr("data-attr-handler");
    var productType = $(this).attr("data-attr-type");
    motor["final product handler"] = productHandler;
    $(".js-final-review-kit-btn").attr("href", "/products/" + motor["final product handler"]);

    if (productType == "Front") {
      $(".productFrontHubMotorBattery").show();
      $(".productMid1Battery").hide();
      $(".productMid2Battery").hide();
      $(".final-product-section").html($(".front-product-details").html());
    } else if (productType == "Mid1") {
      $(".productFrontHubMotorBattery").hide();
      $(".productMid1Battery").show();
      $(".productMid2Battery").hide();
      $(".final-product-section").html($(".mid1-product-details").html());
    } else {
      $(".productFrontHubMotorBattery").hide();
      $(".productMid1Battery").hide();
      $(".productMid2Battery").show();
      $(".final-product-section").html($(".mid2-product-details").html());
    }

    if (motor["type"] == "discover") {
      motor["selected product"] = $(this).attr("data-attr");
    }

    $('html,body').animate({
      scrollTop: $(".quiz-box").offset().top - 200
    }, 500);
  });
  /*Battery BA 1 button click*/

  $(".js-quiz-section-battery-ba1 .btn-green-solid").click(function (e) {
    $(".quiz-section").removeClass("active");
    motor["battery ba 1 title"] = $(this).parent(".content").children("h3").html().toLowerCase();
    motor["battery ba 1"] = $(this).attr("data-attr-battery-ba1").toLowerCase();
    $('html,body').animate({
      scrollTop: $(".quiz-box").offset().top - 200
    }, 500);
    motor["final product handler"] = $(this).attr("data-attr-complete-product-handler");
    $(".final-product-battery-section").html($("." + $(this).attr("data-attr-battery-ba1")).html());
    motor["front status"] = false;
    $(".js-final-review-kit-btn").attr("href", "/products/" + motor["final product handler"]);
    $(".js-quiz-section-battery-ba1").hide();
    $(".js-quiz-section-battery-ba2").show();
  });
  /*Skip button BA 1*/

  $(".js-btn-ba1-skip").click(function (e) {
    $(".js-quiz-section-battery-ba1").hide();
    finalResult();
    $(".final-product-battery-section").hide();
    $(".js-quiz-section-final-result").children(".quiz-three-colum-list-heading-button").addClass("two-column");
    $(".js-final-battery-finder").hide();
    $('html,body').animate({
      scrollTop: $(".quiz-box").offset().top - 200
    }, 500);
  });
  /*Battery BA 2 button click*/

  $(".js-quiz-section-battery-ba2 .btn-green-solid").click(function (e) {
    $(".js-quiz-section-battery-ba2").hide();
    motor["battery ba 2"] = $(this).attr("data-attr-battery-ba2").toLowerCase();
    finalResult();
    $('html,body').animate({
      scrollTop: $(".quiz-box").offset().top - 200
    }, 500);
    $(".js-quiz-section-final-result").children(".quiz-three-colum-list-heading-button").removeClass("two-column");
    $(".js-final-battery-finder").show();
    $(".final-product-battery-section").show();
  });
  /*Function edit quiz*/

  $(".js-edit-quiz").click(function (e) {
    $(".js-quiz-section").hide();
    $(".quiz-section").hide();
    var editStep = $(this).attr("data-attr");
    $(".js-quiz-" + editStep).show();
    $('html,body').animate({
      scrollTop: $(".quiz-box").offset().top - 200
    }, 500);
  });
  /*Setting  product power*/

  var powerFront = $(".js-power-front-hub").attr("data-attr-power");

  if (powerFront == "one") {
    $(".js-power-front-hub").children("ul").children("li:nth-child(1)").addClass("active");
  }

  if (powerFront == "two") {
    $(".js-power-front-hub").children("ul").children("li:nth-child(1)").addClass("active");
    $(".js-power-front-hub").children("ul").children("li:nth-child(2)").addClass("active");
  }

  if (powerFront == "three") {
    $(".js-power-front-hub").children("ul").children("li:nth-child(1)").addClass("active");
    $(".js-power-front-hub").children("ul").children("li:nth-child(2)").addClass("active");
    $(".js-power-front-hub").children("ul").children("li:nth-child(3)").addClass("active");
  }

  var powerMid = $(".js-power-mid-drive").attr("data-attr-power");

  if (powerMid == "one") {
    $(".js-power-mid-drive").children("ul").children("li:nth-child(1)").addClass("active");
  }

  if (powerMid == "two") {
    $(".js-power-mid-drive").children("ul").children("li:nth-child(1)").addClass("active");
    $(".js-power-mid-drive").children("ul").children("li:nth-child(2)").addClass("active");
  }

  if (powerMid == "three") {
    $(".js-power-mid-drive").children("ul").children("li:nth-child(1)").addClass("active");
    $(".js-power-mid-drive").children("ul").children("li:nth-child(2)").addClass("active");
    $(".js-power-mid-drive").children("ul").children("li:nth-child(3)").addClass("active");
  }

  var powerMid1 = $(".js-power-mid-drive-BBS02").attr("data-attr-power");

  if (powerMid1 == "one") {
    $(".js-power-mid-drive-BBS02").children("ul").children("li:nth-child(1)").addClass("active");
  }

  if (powerMid1 == "two") {
    $(".js-power-mid-drive-BBS02").children("ul").children("li:nth-child(1)").addClass("active");
    $(".js-power-mid-drive-BBS02").children("ul").children("li:nth-child(2)").addClass("active");
  }

  if (powerMid1 == "three") {
    $(".js-power-mid-drive-BBS02").children("ul").children("li:nth-child(1)").addClass("active");
    $(".js-power-mid-drive-BBS02").children("ul").children("li:nth-child(2)").addClass("active");
    $(".js-power-mid-drive-BBS02").children("ul").children("li:nth-child(3)").addClass("active");
  }

  var powerMid2 = $(".js-power-mid-drive-BBSHD").attr("data-attr-power");

  if (powerMid2 == "one") {
    $(".js-power-mid-drive-BBSHD").children("ul").children("li:nth-child(1)").addClass("active");
  }

  if (powerMid2 == "two") {
    $(".js-power-mid-drive-BBSHD").children("ul").children("li:nth-child(1)").addClass("active");
    $(".js-power-mid-drive-BBSHD").children("ul").children("li:nth-child(2)").addClass("active");
  }

  if (powerMid2 == "three") {
    $(".js-power-mid-drive-BBSHD").children("ul").children("li:nth-child(1)").addClass("active");
    $(".js-power-mid-drive-BBSHD").children("ul").children("li:nth-child(2)").addClass("active");
    $(".js-power-mid-drive-BBSHD").children("ul").children("li:nth-child(3)").addClass("active");
  }
});